export const ExperimentsConsts = {
  CancellationFeesUoU: 'specs.bookings.CancellationFeesUoU',
  MyBookingsA11y: 'specs.bookings.MyBookingsA11y',
  MyBookingsShowCourseCancellationModal:
    'specs.bookings.MyBookingsShowCourseCancellationModal',
};
